
// スマホ・PC判別
isPhone = function(){
  return navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0
};
